import * as types from '../../action-types';
import AxiosCall from '../../../utils/axios';
import ErrorHandler from '../../../utils/error-handler';

export const withHansaCreateLinkFail = payload => ({
  type: types.WITH_HAMSA_CREATE_LINK_FAIL,
  payload
});

export const withHansaCreateLinkSuccess = payload => ({
  type: types.WITH_HAMSA_CREATE_LINK_SUCCESS,
  payload
});

export const withHansaCreateLink = payload => async dispatch => {
  try {    
    const requestObj = {
      path: "withhansa/create_link",
      method: "POST",
      data: payload
    }
    const data  = await AxiosCall(requestObj);    
    if(data && data.magicLink)  {
        //window.location.href = data.magicLink;
        dispatch(withHansaCreateLinkSuccess(data.magicLink));
    } else if(data && data.error)  {        
        dispatch(withHansaCreateLinkFail(data.message));
    }
    
  } catch (err) {
    const error = ErrorHandler(err);
    console.log('MRA withHansaCreateLink error:', error);  
    dispatch(withHansaCreateLinkFail(error));
  }
}
